import { BaseLayer } from '.'
import { nownoticePointList } from '../../views/Map/ToolsPannel/RightChildPannel/staticData'
import { addProblematicWaterArea } from '../GIS/waterAreaMarker' // 确保路径正确
import * as Cesium from 'cesium'
export class SecondarywaterLayer extends BaseLayer<{
  click(p: any): void
}> {
  layername: string = '危险水域'
  key: string = 'Secondarywater'

  constructor() {
    super()
  }

  async render() {
    if (!this._viewer) return

    // 初始化时直接绘制所有的水域
    const primitives = this.createWaterAreas()
    primitives.forEach((p) => this.layer.primitiveCollection.add(p))
  }

  private createWaterAreas(): Cesium.GroundPrimitive[] {
    // 添加所有的水域
    return nownoticePointList.map((area) => {
      if (!area.coordinates || area.coordinates.length == 0)
        throw new Error('createWaterAreas:coordinates为空')

      const coordinates = area.coordinates[0].map((coordPair) => [coordPair[0], coordPair[1]])
      const groundPrimitive = addProblematicWaterArea(coordinates)
      return groundPrimitive
    })
  }
  bringToTop() {
    if (!this._viewer) return
    this._viewer.scene.primitives.raiseToTop(this.layer.primitiveCollection)
  }
}

let secondaryWaterLayerVisible = false

export function setSecondaryWaterLayerVisibility(visible: boolean): void {
  secondaryWaterLayerVisible = visible
}

export function getSecondaryWaterLayerVisibility(): boolean {
  return secondaryWaterLayerVisible
}
